export default __webpack_public_path__ + "static/media/logo-twitter.13ec57a7.svg";